

import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import RelojChecadorDataService from '../../../Services/Catalogos/RelojChecador';
import CatEmpleados from '../../../Services/Catalogos/CatEmpleados';
import DTOChecadaHomeOffice, { DTOChecadaHomeOfficeAgrupada } from '../../../DTO/DTOEsHomeParams';
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';

interface Props {
  empleadoFiltro: string;
  fechaFiltro: string;
}

export default function SoloChecadasEmpleado({ empleadoFiltro, fechaFiltro }: Props) {
  const [filteredData, setFilteredData] = useState<any[]>([]);
//   const [checadasHome, setChecadasHome] = useState<DTOChecadaHomeOffice[]>([]);
const [checadasHome, setChecadasHome] = useState<DTOChecadaHomeOfficeAgrupada[]>([]);
  const [loading, setLoading] = useState(true);
  const [esHomeOffice, setEsHomeOffice] = useState<boolean | null>(null);

  // Modales y Form
  const [showAgregarModal, setShowAgregarModal] = useState(false);
  const [showEditarModal, setShowEditarModal] = useState(false);
  const [nuevaHora, setNuevaHora] = useState<string>('');
  const [nuevoTipo, setNuevoTipo] = useState<'I' | 'O'>('I');
  const [nuevoComentario, setNuevoComentario] = useState<string>('');
//   const [checadaEditar, setChecadaEditar] = useState<DTOChecadaHomeOffice | null>(null);
const [checadaEditar, setChecadaEditar] = useState<{
  id: number;
  hora: string;
  tipo: 'I' | 'O';
} | null>(null);
  
  const [editHora, setEditHora] = useState<string>('');
  const [editTipo, setEditTipo] = useState<'I' | 'O'>('I');
  const [editComentario, setEditComentario] = useState<string>('');

  // Toast
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState('');
  const [toastHeader, setToastHeader] = useState('');
  const [toastColor, setToastColor] = useState<'success' | 'danger' | 'warning'>('success');



const hoyReal = new Date().toLocaleDateString('sv-SE'); 
const esVistaHoy = fechaFiltro?.split('T')[0] === hoyReal;
 

  const showMessage = (msg: string, header: string, color: 'success' | 'danger' | 'warning' = 'success') => {
    setToastMsg(msg); setToastHeader(header); setToastColor(color); setShowToast(true);
  };

  const getLocalTime = () => {
    const ahora = new Date();
    const tzoffset = ahora.getTimezoneOffset() * 60000; 
    return (new Date(ahora.getTime() - tzoffset)).toISOString().slice(0, 16);
  };

 
  const getUserIdValidado = (): number => {
    const rawId = localStorage.getItem('UserId'); 
    if (!rawId) return 0;
    // Quitamos comillas si existen y convertimos a número
    const cleanId = rawId.replace(/['"]+/g, ''); 
    return parseInt(cleanId);
  };



  const cargarDatos = () => {
    setLoading(true);
    if (esHomeOffice) {
      RelojChecadorDataService.GetChecadasHomeOffice(empleadoFiltro, new Date(fechaFiltro), new Date(fechaFiltro))
        .then(res => { setChecadasHome(res.data); setLoading(false); })
        .catch(() => { setChecadasHome([]); setLoading(false); });
    } else {
      RelojChecadorDataService.getReporteChecadas(fechaFiltro, fechaFiltro)
        .then(res => {
          setFilteredData(res.data.filter((i: any) => i.numeroEmpleado === empleadoFiltro));
          setLoading(false);
        }).catch(() => { setFilteredData([]); setLoading(false); });
    }
  };

  useEffect(() => {
    if (!empleadoFiltro) return;
    CatEmpleados.GetEsHomeOffice(empleadoFiltro).then(res => setEsHomeOffice(res.data.esHomeOffice));
  }, [empleadoFiltro]);

  useEffect(() => {
    if (!empleadoFiltro || !fechaFiltro || esHomeOffice === null) return;
    cargarDatos();
  }, [empleadoFiltro, fechaFiltro, esHomeOffice]);

  // --- HANDLERS ACCIONES ---

  const handleAgregar = () => { 
    setNuevaHora(getLocalTime()); 
    setNuevoTipo('I'); 
    setNuevoComentario(''); 
    setShowAgregarModal(true); 
  };


const abrirEditar = (id: number, hora: string, tipo: 'I' | 'O') => {
  setChecadaEditar({
    id,
    hora,
    tipo
  });

  setEditHora(hora.slice(0, 16));
  setEditTipo(tipo);
  setShowEditarModal(true);
};
  const guardarNuevaChecada = async () => {
    const userId = getUserIdValidado();
    if (userId === 0) {
      showMessage('No se detectó el ID de usuario (UserId).', 'Error de sesión', 'danger');
      return;
    }

    try {
      await RelojChecadorDataService.PostAgregarChecadaHomeOffice({
        NumEmpleado: empleadoFiltro, 
        CheckTime: nuevaHora, 
        CheckType: nuevoTipo,
        UsuarioOperacion: userId,
        Comentario: nuevoComentario || ''
      });
      setShowAgregarModal(false);
      cargarDatos();
      showMessage('Registrado correctamente', 'Éxito');
    } catch { showMessage('Error al guardar', 'Error', 'danger'); }
  };

  const guardarEdicion = async () => {
    if (!checadaEditar) return;
    const userId = getUserIdValidado();

    try {
    

    if (!checadaEditar) return;

await RelojChecadorDataService.PostActualizarChecadaHomeOffice({
  Id: checadaEditar.id,
  NumEmpleado: empleadoFiltro,
  CheckTime: editHora,
  CheckType: editTipo,
  UsuarioOperacion: userId,
  ComentarioNuevo: editComentario
});
      setShowEditarModal(false);
      cargarDatos();
      showMessage('Actualizado', 'Éxito');
    } catch { showMessage('Error al editar', 'Error', 'danger'); }
  };

  const handleEliminar = (id: number) => {
    if (!window.confirm('¿Eliminar registro?')) return;
    const userId = getUserIdValidado();

    RelojChecadorDataService.PostEliminarChecadaHomeOffice({
      Id: id, 
      NumEmpleado: empleadoFiltro, 
      UsuarioOperacion: userId,
      Comentario: 'Borrado'
    }).then(() => { cargarDatos(); showMessage('Eliminado', 'Éxito'); });
  };

  // --- COLUMNAS ---

  const columnsReloj = [
    { name: 'Fecha', selector: (row: any) => row.fecha?.split('T')[0] || '--', width: '100px' },
    { name: 'E1', selector: (row: any) => row.entrada1?.split('T')[1]?.slice(0, 5) || '--:--', width: '70px' },
    { name: 'S1', selector: (row: any) => row.salida1?.split('T')[1]?.slice(0, 5) || '--:--', width: '70px' },
    { name: 'E2', selector: (row: any) => row.entrada2?.split('T')[1]?.slice(0, 5) || '--:--', width: '70px' },
    { name: 'S2', selector: (row: any) => row.salida2?.split('T')[1]?.slice(0, 5) || '--:--', width: '70px' },
  ];


  



const columnsHome = [
  {
    name: 'Fecha',
    selector: (row: DTOChecadaHomeOfficeAgrupada) =>
      row.fecha.split('T')[0],
    width: '100px'
  },
{
  name: 'E1',
  cell: (row: DTOChecadaHomeOfficeAgrupada) =>
    row.entrada1 ? (
      <div>
        <span
          style={{ cursor: 'pointer', color: '#007bff', fontWeight: 'bold' }}
          onClick={() =>
            row.idEntrada1 &&
            abrirEditar(row.idEntrada1, row.entrada1!, 'I')
          }
        >
          {row.entrada1.split('T')[1].slice(0, 5)}
        </span>

        {row.idEntrada1 && (
          <button
            className="btn btn-sm btn-outline-danger ms-1"
            onClick={() => handleEliminar(row.idEntrada1!)}
          >
            X
          </button>
        )}


      </div>
    ) : '--:--'
},
{
  name: 'S1',
  cell: (row: DTOChecadaHomeOfficeAgrupada) =>
    row.salida1 ? (
      <div>
        <span
          style={{ cursor: 'pointer', color: '#dc3545', fontWeight: 'bold' }}
          onClick={() =>
            row.idSalida1 &&
            abrirEditar(row.idSalida1, row.salida1!, 'O')
          }
        >
          {row.salida1.split('T')[1].slice(0, 5)}
        </span>

        {row.idSalida1 && (
          <button
            className="btn btn-sm btn-outline-danger ms-1"
            onClick={() => handleEliminar(row.idSalida1!)}
          >
            X
          </button>
        )}
      </div>
    ) : '--:--'
},
{
  name: 'E2',
  cell: (row: DTOChecadaHomeOfficeAgrupada) =>
    row.entrada2 ? (
      <div>
        <span
          style={{ cursor: 'pointer', color: '#007bff', fontWeight: 'bold' }}
          onClick={() =>
            row.idEntrada2 &&
            abrirEditar(row.idEntrada2, row.entrada2!, 'I')
          }
        >
          {row.entrada2.split('T')[1].slice(0, 5)}
        </span>

        {row.idEntrada2 && (
          <button
            className="btn btn-sm btn-outline-danger ms-1"
            onClick={() => handleEliminar(row.idEntrada2!)}
          >
            X
          </button>
        )}
      </div>
    ) : '--:--'
},
{
  name: 'S2',
  cell: (row: DTOChecadaHomeOfficeAgrupada) =>
    row.salida2 ? (
      <div>
        <span
          style={{ cursor: 'pointer', color: '#dc3545', fontWeight: 'bold' }}
          onClick={() =>
            row.idSalida2 &&
            abrirEditar(row.idSalida2, row.salida2!, 'O')
          }
        >
          {row.salida2.split('T')[1].slice(0, 5)}
        </span>

        {row.idSalida2 && (
          <button
            className="btn btn-sm btn-outline-danger ms-1"
            onClick={() => handleEliminar(row.idSalida2!)}
          >
            X
          </button>
        )}
      </div>
    ) : '--:--'
}

];


  
  return (
    <div className="card shadow-none border-0 p-2">
      <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
        {esHomeOffice && esVistaHoy && (
          <button className="btn btn-primary btn-sm rounded-pill px-3 shadow-sm" onClick={handleAgregar}>
            <i className="fa fa-plus me-1"></i> Agregar Checada
          </button>
        )}
      </div>

      <DataTable 
        columns={esHomeOffice ? columnsHome : columnsReloj} 
        data={esHomeOffice ? checadasHome : filteredData} 
        progressPending={loading}
        noDataComponent={<div className="p-4 text-muted small">No hay registros para este día.</div>}
        dense 
      />

      {/* MODAL AGREGAR */}
      {showAgregarModal && (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0">
              <div className="modal-header bg-primary text-white py-2">
                <h6 className="modal-title">Registrar Movimiento</h6>
                <button className="btn-close btn-close-white" onClick={() => setShowAgregarModal(false)}></button>
              </div>
              <div className="modal-body p-4 text-center">
                <label className="form-label small fw-bold text-muted mb-1">HORA DEL SISTEMA</label>
                <input type="datetime-local" className="form-control form-control-lg text-center bg-light mb-4" value={nuevaHora} readOnly />
                <div className="row g-2 mb-4">
                    <div className="col"><button className={`btn py-3 w-100 fw-bold ${nuevoTipo === 'I' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setNuevoTipo('I')}>ENTRADA</button></div>
                    <div className="col"><button className={`btn py-3 w-100 fw-bold ${nuevoTipo === 'O' ? 'btn-danger' : 'btn-outline-danger'}`} onClick={() => setNuevoTipo('O')}>SALIDA</button></div>
                </div>
                <input type="text" className="form-control" placeholder="Nota..." value={nuevoComentario} onChange={(e) => setNuevoComentario(e.target.value)} />
              </div>
              <div className="modal-footer border-0">
                <button className="btn btn-link text-muted" onClick={() => setShowAgregarModal(false)}>Cerrar</button>
                <button className="btn btn-primary px-4 shadow-sm" onClick={guardarNuevaChecada}>Guardar Registro</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODAL EDITAR */}
      {showEditarModal && (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content border-0 shadow">
              <div className="modal-header bg-warning py-2">
                <h6 className="modal-title fw-bold small">EDITAR CHECADA</h6>
              </div>
              <div className="modal-body p-3">
                <select className="form-select mb-3" value={editTipo} onChange={(e) => setEditTipo(e.target.value as 'I' | 'O')}>
                    <option value="I">ENTRADA</option>
                    <option value="O">SALIDA</option>
                </select>
                <input type="text" className="form-control mb-2" value={editComentario} onChange={(e) => setEditComentario(e.target.value)} />
              </div>
              <div className="modal-footer border-0 pt-0">
                <button className="btn btn-sm btn-secondary" onClick={() => setShowEditarModal(false)}>Cancelar</button>
                <button className="btn btn-sm btn-warning fw-bold" onClick={guardarEdicion}>Actualizar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <MsgInformativo show={showToast} msg={toastMsg} header={toastHeader} msgColor={toastColor} time={3000} closeToast={() => setShowToast(false)} />
    </div>
  );
}